import {get} from 'lodash';
import {assocArrayLength} from '../../../../lib/utility/helpers';
import createBaseLayer from './base-layer';

const buildResultLookupTable = props => {
  // props.Regions holds <RegionAttributeHeaders> with Id, Name;
  // The Id here is the Name in the Region.Attributes.Attribute items
  const attributeHeaders = get(props, 'Attributes.Attribute_asArray', []);
  const regionHeaders = get(props, 'Regions.RegionAttributeHeaders.AttributeHeader', []);

  attributeHeaders.forEach(header => {
    header.regionHeader = regionHeaders.find(rh => rh._Name === header._Name);
  });

  const regionsRaw = get(props, 'Regions.Region_asArray');
  const regions = (!regionsRaw) ? [] : regionsRaw.map(region => {
    const {_Id, _InputRegionId, Attributes} = region;
    const props = !Attributes ? {} : Attributes.Attribute_asArray.map(a => {
      const {GlobalId, HeaderGlobalId, _Id, _Name, _Value} = a;
      return {
        GlobalId,
        HeaderGlobalId,
        _Id,
        _Name,
        _Value
      };
    });
    return {
      _Id,
      _InputRegionId,
      props
    };
  });
  const table = {regions, regionHeaders, attributeHeaders};

  regionHeaders.forEach(header => {
    if (header) {
      table[header._Id] = header._Name;
    }
  });

  return table;
};

export default (props, model) => {
  const attributes = {}; // analysis results for the layer { name, value }
  const regionResultsLookup = buildResultLookupTable(props); // lookup of region's analysis results (attribute) Id to the actual attribute Name

  const self = createBaseLayer(model);

  self.getLayerResults = function () {
    return attributes;
  };
  self.getLayerResultsLength = function () {
    return assocArrayLength(attributes);
  };
  self.getRegionResultsLUT = function () {
    return regionResultsLookup;
  };

  model.layerType = 'analysis';

  return self;
};



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/annotations/layer/types/analysis-layer.js